import React from "react";
import './ClientProfile.css'

const ClientProfile = ({ client }) => (
    <div className="client-profile">
      --- CLIENT DETAILS ---
    </div>
  );

export default ClientProfile